/**
 * The timeline action of a timeout. Timeline events are told apart by this
 * label (see `ACTIONS` in `reducers/game-timeline-parser.js`), and the edit
 * list is filtered by it.
 */
export const TIMEOUT_ACTION = 'Timeout'

/** The event type of a timeout in the offline queue (`POST /games/bulkscoring`). */
export const TIMEOUT_QUEUE_TYPE = 'timeout'

/** The time field takes up to four digits, read as MMSS, like every scoring time screen. */
export const TIMEOUT_TIME_MAX_DIGITS = 4

/**
 * The most timeouts the web's Edit Timeline sets for one team in one period
 * of a basic-stats game: more than any team calls. The API refuses more
 * (`SetTimeoutCountRequest::MOST_TIMEOUTS`).
 */
export const TIMEOUT_COUNT_MAX = 99

/** Translation keys of everything the app and the web say about a timeout. */
export const TIMEOUT_TEXT = {
  rowTitle: 'Scoring:timeouts',
  event: 'Scoring:timeout',
  homeTitle: 'Scoring:homeTimeout',
  visitorTitle: 'Scoring:visitorTimeout',
  editTitle: 'Scoring:editTimeout',
  /** The sheets that set a team's timeouts in a period of a basic-stats game. */
  editHomeCount: 'Scoring:editHomeTimeouts',
  editVisitingCount: 'Scoring:editVisitingTimeouts',
  /** The one step of the timeout screen. */
  stepTitle: 'Scoring:timeOfTimeout',
  /** What the step bar's ">" does, read out by VoiceOver and TalkBack. */
  saveAction: 'Scoring:saveTimeout',
  /** The header bin, read out by VoiceOver and TalkBack. */
  deleteAction: 'Scoring:deleteTimeout',
  timePlaceholder: 'Scoring:timeoutTimePlaceholder',
  confirm: 'common:confirm',
  invalidTime: 'errors:pleaseEnterValidTime',
  outsidePeriod: 'errors:enterClockTimeWithinPeriod',
  notSaved: 'Scoring:timeoutNotSaved',
  notDeleted: 'Scoring:timeoutNotDeleted',
  newTitle: 'Scoring:newTimeout',
  selectTeam: 'Web:selectATeam',
  areYouSure: 'Web:areYouSure',
  cantBeUndone: 'Web:deletionCantBeUndone',
  cancel: 'common:cancel',
  delete: 'common:delete',
} as const
